<template>
	<section>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
	        <h1 class="h3 mb-0 text-gray-800">Auditoria</h1>

			<div>
				<pdfBtn 
					:filter="string_filter"  
					type="datatable" 
					title="auditoria"
					datatable="Log_Use"
					:external="false"
					:data_head="data_head" 
					:data_body="data_body" 
				/>
			</div>
	    </div>

	    <filtros :filter_data="filter_data" @filtrar="filtrar" />

		<table class="table table-striped table-sm">
    		<thead align="center">
    			<th @click="orderBy('id')"     >ID			<font-awesome-icon v-if="direction.by == 'id'"      :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('user_id')">USUARIO		<font-awesome-icon v-if="direction.by == 'user_id'" :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('date')"   >DATA		<font-awesome-icon v-if="direction.by == 'date'"    :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('time')"   >HORA		<font-awesome-icon v-if="direction.by == 'time'"    :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('ip')"     >IP			<font-awesome-icon v-if="direction.by == 'ip'"      :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('action')" >REGISTRO	<font-awesome-icon v-if="direction.by == 'action'"  :icon="order_icon" size="xs" /></th>
    			<th></th>
    		</thead>

			<transition mode="out-in" name="leftIn">
				<tbody v-if="registros" align="center">
	    			<tr v-for="(log, index) in registros.result.data" :key="index">
						<td>{{ log.id }}</td>
						<td>{{ log.name }}</td>
						<td>{{ log.date | moment("DD/MM/Y") }}</td>
						<td>{{ log.time }}</td>
						<td>{{ log.ip }}</td>
						<td>{{ log.action }}</td>
						<td></td>
					</tr>
	    		</tbody>
	    		<div v-else><Loading/></div>
			</transition>
    	</table>

    	<controls :data="constrol_data" @refresh="navigate"  @alert="show_alert" />
	</section>
</template>

<script>
	import api      from "@/mixins/api.js"
	import pdfBtn   from "@/components/Tools/Pdf.vue"
	import filtros  from "@/components/Tools/Filtro.vue"
	import controls from "@/components/Tools/Table_Control.vue"

	export default {
		name: "Auditoria",
		props: ["table", "method"],
		mixins: [api],
		components: { controls, filtros, pdfBtn },

		data() {
			return {
				registros: null,
				constrol_data: {},
				modal_data: {},
				action: "",

				alert: { type: "", msg: "" },
				direction: { order: "desc", by: "id" },

				pagination: "10?",
				string_filter: "",

				filter_data: [
					{ 
						name: "id",      
						label: "id",      
						type: "text",   
						data_get: ""
					},
					{ 
						name: "date",    
						label: "data",    
						type: "date",   
						data_get: ""
					},
					{ 
						name: "user_id", 
						label: "usuário", 
						type: "select", 
						data_get: "User"
					}
				],
				data_head: ["ID", "USUÁRIO", "DATA", "HORA", "IP", "REGISTRO"],
				data_body: ["id", "name", "date", "time", "ip", "action"]
			}
		},

		created() {
			this.get_data();
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`;
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down";
			}
		},

		methods: {
			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc';
				}else{
					this.direction.by = payload;
				}

				this.get_data();
			},

			filtrar(payload) {
				this.string_filter = payload;
				this.get_data();
			},

			async get_data() {
				this.registros = null;
				this.registros = await this.GET("Log/Use", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}`);

				this.constrol_data = {
					current_page: this.registros.result.current_page,
					last_page:    this.registros.result.last_page,
					per_page:     this.registros.result.per_page,
					total:        this.registros.result.total,
				}
			},

			navigate(payload) {
				this.pagination = payload;
				this.get_data();
			},

			view(unidade) { 
				this.modal_data = unidade;
				this.action = "view";
				$("#modal-cadastro-unidade").modal();
			},

			add() { 
				this.modal_data = {};
				this.action = "add";
				$("#modal-cadastro-unidade").modal();
			},

			show_alert(payload) {
				this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger";
				this.alert.msg  = payload.result;

				$("#modal-cadastro-unidade").modal('hide');
				this.get_data();
				$("#app-alert").show();
				setTimeout(() => $("#app-alert").hide(), 3000 );
			},
		},
	};
</script>

<style>
	
</style>